export const SupportAvailability = Object.freeze({
  Open: 'open',
  Closed: 'closed',
  OnHoliday: 'on-holiday'
});
export const SupportResourcesLink = Object.freeze({
  DOCUMENTATION: 'Documentation',
  WIKI: 'Wiki',
  COMMUNITY: 'Community',
  ATLASSIAN_COMMUNITY: 'Atlassian Community',
  EMAIL: 'Email',
  SUPPORT_WEBSITE: 'Support website',
  ISSUE_TRACKER: 'Issue tracker',
  STATUS_PAGE: 'Status Page'
});